/**
 * CihPullQuoteBand — full-bleed dark caesura for mid-page pull quotes.
 * Used as § 02 on CCO, CTP, and Framework pages. Absent on Challenge
 * (the whole hero is the dark moment there) and on Article.
 *
 * Aliases: pull quote band, dark caesura, mission band
 */

type Props = {
  readonly quote: string;
  readonly attribution?: string | null;
};

export function CihPullQuoteBand({ quote, attribution }: Props) {
  return (
    <section className="border-y border-gray-900 bg-gray-950 py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-4 xl:px-0">
        <blockquote className="font-heading text-3xl leading-tight font-normal tracking-tight text-white md:text-4xl">
          <span
            aria-hidden="true"
            className="mr-1 align-[-0.15em] text-5xl leading-none text-purple-300"
          >
            “
          </span>
          {quote}
        </blockquote>
        {attribution ? (
          <div className="mt-7 text-xs font-medium tracking-[0.22em] text-gray-400 uppercase">
            — {attribution}
          </div>
        ) : null}
      </div>
    </section>
  );
}
